import {observer} from "mobx-react";
import PageAncestor from "../../../core/common/page/pageAncestor";
import {MODULE, PageProps} from "../../../core/metamodel/metaConstant";
import {loc} from "../../../core/common/config/locales";
import {AREA_LIST, LIFESPAN_LIST} from "../../gridsContants";
import gridService from "../../../core/grid/gridService";
import GridCompConnected from "../../../core/grid/component/gridCompConnected";
import mdEntityService from "../../../core/metamodel/mdEntityService";
import React from "react";


@observer
export default class AreaList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.sbtool;
  static title = loc.i18n`Area`;
  static icon = 'list';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("AreaList#fetchData(%s)", AREA_LIST);

    return gridService.fetchGrids(AREA_LIST)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(AREA_LIST);
      });
  }

  render() {
    let { params, query } = this.props;


    return (
      <GridCompConnected grid={gridService.getOrCreateGrid(AREA_LIST)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query} />
    );
  }


}



// WEBPACK FOOTER //
// ./src/sbtool/page/project/areaList.tsx